import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AsignarPermisosExpeidenteDto } from '../dto/expediente/asignar-permisos-expediente.dto';

@Injectable({
  providedIn: 'root',
})
export class PermisosExpedienteService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/permisos-expediente';

  constructor(private http: HttpClient) {}

  asignarPermisosExpediente(
    request: AsignarPermisosExpeidenteDto
  ): Observable<any> {
    return this.http.post(`${this.apiUrl}${this.baseUrl}`, request);
  }

  consultarUsuarioIdentificacion(
    identificacion: string,
    idExpediente: number
  ): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}${this.baseUrl}/consultarUsuarioIdentificacion/${identificacion}/expediente/${idExpediente}`
    );
  }

  consultarUsuarioAsignados(idExpediente: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}${this.baseUrl}/expediente/${idExpediente}`
    );
  }

  cambiarEstadoPermisoExpediente(idPermisoExpediente: number, idUsuario: number): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}${this.baseUrl}/actualizarEstado/${idPermisoExpediente}`,
      { idUsuario }
    );
  }
}
